import React from "react";

// Import Style
import {
	Nav,
	NavBarContainer,
	NavLogo,
	MobileIcon,
	NavLogoImg,
} from "./Header.styles";

import { List } from "phosphor-react";
import NavMenus from "./NavMenu";

function Navbar({ toggle, changeColor }) {
	return (
		<>
			<Nav changeColor={changeColor}>
				<NavBarContainer>
					<NavLogo to="/">
						<NavLogoImg
							changeColor={changeColor}
							src={process.env.PUBLIC_URL + "img/Logo.png"}
							alt="logo"
						/>
					</NavLogo>
					<MobileIcon onClick={toggle} changeColor={changeColor}>
						<List size={36} />
					</MobileIcon>
					<NavMenus changeColor={changeColor} />
				</NavBarContainer>
			</Nav>
		</>
	);
}

export default Navbar;
